module.exports = __webpack_public_path__ + "static/media/AiMessage2.a56ddb86.png";